import React from 'react';
import PropTypes from 'prop-types';
import MotifBadge from '@ey/motif-react-wrapper/Badge';

export default function Badge(props) {
	const {variant, value, overlap, className, title} = props;

	return <MotifBadge className={className} variant={variant ? variant : 'alt'} value={value} overlap={overlap} title={title} />;
}

Badge.defaultProps = {
	value: 0,
	variant: 'alt',
	overlap: false,
	title: ''
};

Badge.propTypes = {
	variant: PropTypes.string,
	value: PropTypes.number,
	overlap: PropTypes.bool,
	title: PropTypes.string
};
